
export const isShowListFetching = state => {
  return state.shows && state.shows.list && state.shows.list.isFetching
};
